/**
 * If the planner is requesting a quote from a specific profile and
 * they choose an existing event then we want to submit the form
 * right now. There's nothing else to do.
 *
 * See: update-contact-list-submit-button.js for similar logic in
 * a different context.
 */
function updateExistingEventSubmitButton() {
	const quoteRequest = this.collect();
	const context = quoteRequest.get('context');

	if (context !== 'profile') {
		// Nothing to do when not in the profile context.
		return;
	}

	const nextStepButton = this.currentStepElement.querySelector('.js-quote-step-next');
	let nextStepButtonLabel = nextStepButton.querySelector('.ladda-label');

	if (!nextStepButtonLabel) {
		nextStepButtonLabel = nextStepButton;
	}

	const existingEvent = quoteRequest.get('event_role');
	if (!existingEvent || existingEvent === 'new') {
		// Switch to "Next" button
		delete nextStepButton.dataset.submit;
		nextStepButtonLabel.textContent = 'Next';
		console.log('No existing event selected. Next step mode!');
	} else {
		// Switch to "Submit" button
		nextStepButton.dataset.submit = 'true';
		nextStepButtonLabel.textContent = 'Submit';
		console.log('Existing event selected. Submit mode!');
	}
}

export {
	updateExistingEventSubmitButton
}